import { c as _c } from "react/compiler-runtime";
export default function FileIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M8 28V4h8v7a1 1 0 0 0 1 1h7v16H8zM18 5.414L22.586 10H18V5.414zm7.707 4.879l-8-8A.996.996 0 0 0 17 2H7a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V11a.999.999 0 0 0-.206-.608l-.087-.099zM10 16h12v-2H10v2zm0 4h12v-2H10v2zm0 4h5v-2h-5v2z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}